"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftError = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const lodash_1 = require("lodash");
const constants_1 = require("../../../../constants");
const elements_1 = require("../../../../elements");
const translate_1 = require("../../../../translate");
const consts_1 = require("../consts");
const ErrorWrapper = (0, styled_1.default)(elements_1.Div)({
    position: 'absolute',
    top: -5,
    right: -5,
    zIndex: consts_1.composableZIndex.shiftError,
    width: 'fit-content',
});
const ShiftError = (props) => {
    const t = (0, translate_1.useTranslations)();
    if (!props.errors.length)
        return null;
    const isWarning = props.errors.every((e) => e.isWarning);
    return ((0, jsx_runtime_1.jsx)(elements_1.Tooltip, { text: (0, lodash_1.uniq)(props.errors.map((e) => e.error))
            .sort((a, b) => a.localeCompare(b, t.$locale))
            .join(', '), intent: "warning", children: (0, jsx_runtime_1.jsx)(elements_1.Tooltip.Trigger, { asChild: true, children: (0, jsx_runtime_1.jsx)(ErrorWrapper, { children: (0, jsx_runtime_1.jsx)(elements_1.Icon, { name: "DuotoneExclamationCircle", color: isWarning ? constants_1.Color.YELLOW : constants_1.Color.RED, design: "solid", size: "md-plus" }) }) }) }));
};
exports.ShiftError = ShiftError;
